<template>
    <div uk-grid class="uk-grid-small uk-flex-center" style="max-width: 80vw; margin: auto;">
      <div v-for="(widget, index) in sidebar_widgets" class="uk-width-1-3@m">
       <div class="uk-card uk-card-default uk-card-body widget">
          <h2 class="widget-title" v-if="widget.display_title == 1" v-html="widget.title"></h2>
          <h2 class="widget-title" v-if="widget.display_title != 1" >&nbsp;</h2>
          <div class="widget-content" v-html="widget.content"></div>
        </div>
      </div>
    </div>
</template>

<script>

import axios from "axios";
import { settings } from "@/settings";
let API_SERVER = settings.API_SERVER;

export default {
  name: 'WidgetSidebarView',
  data: function () {
    return {
    sidebar_widgets: [],
  }},
  methods: {
    logout() {
      window.UIkit.offcanvas(this.$refs.offcanvasMenu).hide();
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
    loadWebWidgets(){
          
          let page_slug = this.$route.params.slug;
          var clean_slug = "";
          if(page_slug != undefined){
            clean_slug = page_slug.replace(".html","");
            if(clean_slug == "index"){
              console.log("widget sidebar index.html route must go one level back");
              console.log(this.$route);
              clean_slug = this.$route.path.replace("/index.html","");
              clean_slug = clean_slug.replace("/","");
            }
          }


          //console.log(clean_slug);
          if(!clean_slug || clean_slug == ""){
            clean_slug = "home";
          }
          else {
            clean_slug += ",home";
          }
          //console.log(clean_slug);

          let status_filter = "published";
          if(this.debug){
            status_filter += ",debug";
          }

          let vm = this;
          vm.sidebar_widgets = [];
          axios
          .get(API_SERVER + '/_/custom/greengobus/web/getwidgets/'+status_filter+'/'+clean_slug)
          .then(response => {

            response.data.data.forEach((widget) => {

                //console.log(widget.display_title);

                if(widget.position == "sidebar"){
                  vm.sidebar_widgets.push(widget);
                }

            });

          });
        },
    },
    updated: function (){
    	//console.log("updated");
    	//this.loadWebWidgets();
    },
    mounted: function () {
        //console.log("mounted");
        //this.loadWebWidgets();
    },
    created: function (){
    	//console.log("created");
      this.loadWebWidgets();
    },
}
</script>